import { cn } from "@/lib/utils";
import { CompaireLogo } from "./CompaireLogo";

interface BrandedLoadingSpinnerProps {
  message?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function BrandedLoadingSpinner({
  message = "Loading Compaire...",
  className,
  size = "md",
}: BrandedLoadingSpinnerProps) {
  const logoSize = {
    sm: "lg" as const,
    md: "xl" as const,
    lg: "xl" as const,
  };

  return (
    <div
      className={cn(
        "flex min-h-[200px] flex-col items-center justify-center gap-4",
        className
      )}
    >
      <div className="animate-pulse">
        <CompaireLogo
          variant="full"
          size={logoSize[size]}
          linkToHome={false}
        />
      </div>
      <p className="text-sm text-muted-foreground animate-fade-in">
        {message}
      </p>
    </div>
  );
}

export default BrandedLoadingSpinner;
